"use client"
import { n as jsxRuntimeExports, r, o as u, Q, u as useMparticle, a as isOfferBanner, G, U, c as getOfferUrl, g as getAuthToken, i as isAuthTokenExpired, W, D, j as updateKonversion, k as konversionType } from "./TrackPageScroll-6c271011.mjs";
import { M, T, m, l } from "./TrackPageScroll-6c271011.mjs";
import { useEffect, useCallback, useRef } from "react";
const getActionElement = (element, rootElement) => {
  if (element.nodeName === "BUTTON" && element.parentNode && element.parentNode.nodeName === "A") {
    return element.parentNode;
  }
  if (element.nodeName === "BUTTON" || element.nodeName === "A") {
    return element;
  }
  if (element === rootElement || !element.parentNode) {
    return;
  }
  return getActionElement(element.parentNode, rootElement);
};
const getAttributeAsString = (element, key) => element.getAttribute(key);
const getAttributeAsNumber = (element, key) => {
  const elementAttributeValue = element == null ? void 0 : element.getAttribute(key);
  if (elementAttributeValue) {
    return parseInt(elementAttributeValue, 10);
  }
};
function TrackAllActionItems({
  rootElementQuery,
  eventAttributes,
  children
}) {
  const { trackEvent } = useMparticle();
  useEffect(() => {
    const rootElement = document.querySelector(rootElementQuery);
    const onClick = (e) => {
      if (!rootElement) {
        return;
      }
      const actionElement = getActionElement(e.target, rootElement);
      if (actionElement) {
        const element_text = actionElement.textContent ?? "";
        const element_destination_page_location = getAttributeAsString(
          actionElement,
          "href"
        );
        const array_element_id = getAttributeAsString(
          actionElement,
          "data-array-element"
        );
        const array_element_position = getAttributeAsNumber(
          actionElement,
          "data-array-position"
        );
        const element_id = getAttributeAsString(actionElement, "data-element-id") ?? actionElement.nodeName.toLowerCase();
        trackEvent(r.click_generic, u.Other, {
          element_position: Q.main,
          element_text,
          content_call_to_action: element_text,
          ...element_destination_page_location ? { element_destination_page_location } : {},
          ...array_element_id ? { array_element_id } : {},
          ...typeof array_element_position !== "undefined" ? { array_element_position } : {},
          element_id,
          ...eventAttributes
        });
      }
    };
    if (rootElement) {
      rootElement.addEventListener("click", onClick);
    }
    return () => {
      if (rootElement) {
        rootElement.removeEventListener("click", onClick);
      }
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
}
const offerClickEventMapper = (index, offer) => {
  return !offer.isAdvert ? {
    merchant_id: offer.merchant.id,
    merchant_name: offer.merchant.name,
    merchant_hyphenated_string: offer.merchant.hyphenatedString,
    merchant_base_cashback_rate: offer.clientCommissionString
  } : {};
};
const storeClickEventMapper = (index, store) => {
  return !store.isAdvert ? {
    merchant_id: store.merchantId,
    merchant_name: store.name,
    merchant_hyphenated_string: store.hyphenatedString,
    merchant_base_cashback_rate: store.clientCommissionString
  } : {
    merchant_id: store.id,
    merchant_name: store.merchantName,
    merchant_hyphenated_string: store.adClickUrl,
    merchant_base_cashback_rate: store.merchantCommissionString
  };
};
const runOfMarketClickEventMapper = (index, runOfMarket) => {
  return {
    merchant_hyphenated_string: runOfMarket.attributes.merchant_hyphenated_string
  };
};
const articleClickEventMapper = (index, article) => {
  return {
    advertiser_name: article.attributes.advertiser_name,
    merchant_hyphenated_string: article.attributes.merchant_hyphenated_string
  };
};
const offerBannerClickEventMapper = (index, offer, mapperConfig) => {
  return isOfferBanner(offer) ? offerClickEventMapper(index, offer) : {};
};
const offerBannerEventMapper = (index, offer) => {
  return isOfferBanner(offer) ? {
    merchant_id: offer.merchant.id,
    merchant_name: offer.merchant.name,
    merchant_hyphenated_string: offer.merchant.hyphenatedString,
    merchant_base_cashback_rate: offer.clientCommissionString
  } : {};
};
const offerProductMapper = (index, offer, config) => {
  var _a, _b, _c;
  return !offer.isAdvert ? {
    id: `${index}`,
    name: offer.merchant.hyphenatedString,
    price: 0,
    custom_attributes: {
      content_descriptor: offer.description,
      content_image_url: offer.offerBackgroundImageUrl,
      content_call_to_action: offer.title,
      parent_element: config.parent_element,
      coupon_code: offer.couponCode
    }
  } : {
    name: offer.adName,
    price: 0,
    id: `${index}`,
    custom_attributes: {
      content_descriptor: "",
      content_image_url: config.device && config.device === "mobile" ? offer.adMobileImageUrl : offer.adDesktopImageUrl,
      content_call_to_action: offer.adImpressionUrl,
      parent_element: config.parent_element,
      advertiser_name: offer.advertiserName,
      advertiser_id: offer.advertiserId,
      flight_id: offer.flightId,
      campaign_id: offer.campaignId,
      element_destination_page_location: offer.rawClickUrl,
      advertising_keywords: (_a = offer.keywords) == null ? void 0 : _a.join(","),
      ad_size_id: offer.adSizeId,
      ad_id: offer.id,
      content_type: G.ads,
      content_provider: U.kevel,
      content_friendly_name: offer.adName,
      advertising_priority_weight: offer.priorityWeight,
      ad_click_event_url: (_b = offer.eventUrls) == null ? void 0 : _b[2],
      ad_view_event_url: (_c = offer.eventUrls) == null ? void 0 : _c[1]
    }
  };
};
const storeProductMapper = (index, store, config) => {
  var _a, _b, _c;
  if (!store.isAdvert) {
    return {
      id: `${index}`,
      name: store.hyphenatedString,
      // Safe to access here
      price: 0,
      custom_attributes: {
        content_descriptor: "",
        content_image_url: store.backgroundImageUrl,
        // Safe to access here
        parent_element: config.parent_element,
        position: `${index}`
      }
    };
  } else {
    const storeAd = store;
    return {
      id: `${index}`,
      price: 0,
      name: "merchantName" in store ? storeAd.merchantName : storeAd.advertiserName,
      custom_attributes: {
        content_descriptor: "",
        content_image_url: storeAd.merchantLogoOverride ? storeAd.merchantLogoOverride : storeAd.merchantLogo,
        // Safe to access here
        parent_element: config.parent_element,
        position: `${index}`,
        ad_size_id: storeAd.adSizeId,
        ad_id: storeAd.id,
        advertiser_name: storeAd.advertiserName,
        advertiser_id: storeAd.advertiserId,
        advertising_keywords: (_a = storeAd.keywords) == null ? void 0 : _a.join(","),
        advertising_priority_weight: storeAd.priorityWeight,
        ad_click_event_url: (_b = storeAd.eventUrls) == null ? void 0 : _b[2],
        ad_view_event_url: (_c = storeAd.eventUrls) == null ? void 0 : _c[1]
      }
    };
  }
};
const bannerProductMapper = (index, banner, config) => {
  var _a, _b, _c;
  return {
    id: `${index}`,
    name: banner.name,
    price: 0,
    custom_attributes: {
      content_descriptor: "",
      content_image_url: config.device && config.device === "mobile" ? banner.mobileBrowserImageUrl : banner.desktopImageUrl,
      parent_element: config.parent_element,
      ad_id: banner.id,
      ad_size_id: banner.adSizeId,
      advertiser_id: banner.advertiserId,
      advertiser_name: banner.advertiserName,
      campaign_id: banner.campaignId,
      advertising_keywords: (_a = banner.keywords) == null ? void 0 : _a.join(","),
      advertising_priority_weight: banner.priorityWeight,
      content_type: banner.advertiserId ? G.ads : G.null,
      content_provider: banner.advertiserId ? U.kevel : U.other,
      content_friendly_name: banner.name,
      content_call_to_action: banner.rawClickUrl,
      element_destination_page_location: banner.rawClickUrl,
      element_position: Q.top,
      flight_id: banner.flightId,
      ad_click_event_url: (_b = banner.eventUrls) == null ? void 0 : _b[2],
      ad_view_event_url: (_c = banner.eventUrls) == null ? void 0 : _c[1]
    }
  };
};
const secondaryBannerProductMapper = (index, banner, config) => {
  var _a, _b, _c;
  return {
    id: `${index}`,
    name: banner.title,
    price: 0,
    custom_attributes: {
      content_descriptor: "",
      content_image_url: config.device && config.device === "mobile" ? `${banner.contentUrl}/${banner.mobile}` : `${banner.contentUrl}/${banner.desktop}`,
      ad_id: banner.id,
      ad_size_id: banner.adSizeId,
      advertiser_id: banner.advertiserId,
      advertiser_name: banner.advertiserName,
      campaign_id: banner.campaignId,
      element_destination_page_location: banner.rawClickUrl,
      advertising_keywords: (_a = banner.keywords) == null ? void 0 : _a.join(","),
      advertising_priority_weight: banner.priorityWeight,
      content_type: banner.advertiserId ? G.ads : G.null,
      content_provider: banner.advertiserId ? U.kevel : U.other,
      content_friendly_name: banner.title,
      content_call_to_action: banner.rawClickUrl,
      flight_id: banner.flightId,
      element_position: Q.bottom,
      ad_click_event_url: (_b = banner.eventUrls) == null ? void 0 : _b[2],
      ad_view_event_url: (_c = banner.eventUrls) == null ? void 0 : _c[1]
    }
  };
};
const runOfMarketProductMapper = (index, runOfMarket, config) => {
  return {
    id: `${index}`,
    name: runOfMarket.attributes.title,
    price: 0,
    custom_attributes: {
      advertiser_name: runOfMarket.attributes.title,
      parent_element: config.parent_element
    }
  };
};
const categoryBannerProductMapper = (index, banner, config) => {
  var _a, _b, _c;
  return {
    id: `${index}`,
    name: banner.advertiserName,
    price: 0,
    custom_attributes: {
      content_descriptor: "",
      content_image_url: config.device && config.device === "mobile" ? `${banner == null ? void 0 : banner.contentUrl}/${banner == null ? void 0 : banner.mobile}` : `${banner == null ? void 0 : banner.contentUrl}/${banner == null ? void 0 : banner.desktop}`,
      parent_element: config.parent_element,
      ad_id: banner.id,
      ad_size_id: banner.adSizeId,
      advertiser_id: banner.advertiserId,
      advertiser_name: banner.advertiserName,
      campaign_id: banner.campaignId,
      advertising_keywords: (_a = banner.keywords) == null ? void 0 : _a.join(","),
      advertising_priority_weight: banner.priorityWeight,
      content_type: banner.advertiserId ? G.ads : G.null,
      content_provider: banner.advertiserId ? U.kevel : U.other,
      content_friendly_name: banner.title,
      content_call_to_action: banner.rawClickUrl,
      element_destination_page_location: banner.rawClickUrl,
      element_position: Q.top,
      flight_id: banner.flightId,
      ad_click_event_url: (_b = banner.eventUrls) == null ? void 0 : _b[2],
      ad_view_event_url: (_c = banner.eventUrls) == null ? void 0 : _c[1]
    }
  };
};
const articleProductMapper = (index, article, config) => {
  return {
    id: `${index}`,
    name: article.attributes.title,
    price: 0,
    custom_attributes: {
      advertiser_name: article.attributes.advertiser_name,
      parent_element: config.parent_element,
      content_type: G.articles
    }
  };
};
const offerBannerProductMapper = (index, offer, config) => {
  return isOfferBanner(offer) ? {
    id: `${index}`,
    name: offer.merchant.name,
    price: 0,
    custom_attributes: {
      content_descriptor: "",
      content_image_url: offer.offerBackgroundImageUrl,
      parent_element: config.parent_element,
      content_type: G.null,
      content_friendly_name: offer.title,
      content_call_to_action: getOfferUrl(offer),
      element_destination_page_location: getOfferUrl(offer),
      element_position: Q.top
    }
  } : bannerProductMapper(index, offer, config);
};
const mapProductWithMappers = (index, item, productMappers, mapperConfig, currentPage) => {
  return productMappers.reduce((acc, productMapper) => {
    const newProduct = productMapper(Number(index), item, mapperConfig);
    return {
      ...acc,
      ...newProduct,
      custom_attributes: {
        array_element_pagination: currentPage,
        array_element_position: index,
        ...acc.custom_attributes,
        ...newProduct.custom_attributes
      }
    };
  }, {});
};
function useCarouselClickTracking(carouselType, productMappers, eventMappers, attributeOverrides, event = r.click_web_merchant, carouselTrackingConfig) {
  const { trackProductActionEvent } = useMparticle();
  const logEvent = useCallback(
    async (index, item, currentPage, itemsPerPage, additionalItems) => {
      var _a, _b, _c, _d;
      const token = await getAuthToken();
      const isSignedIn = !!(token && !isAuthTokenExpired());
      const productEventMapperConfig = {
        parent_element: carouselType,
        device: carouselTrackingConfig == null ? void 0 : carouselTrackingConfig.device
      };
      const customAttributes = (eventMappers || []).reduce(
        (acc, eventMapper) => {
          const newProduct = eventMapper(
            Number(index),
            additionalItems ? additionalItems[index] : item,
            productEventMapperConfig
          );
          return {
            ...acc,
            ...newProduct
          };
        },
        {
          cashrewards_event_name: event,
          signed_in: isSignedIn,
          array_element_id: carouselType,
          array_element_type: W.carousel,
          array_element_pagination: currentPage,
          array_element_page_count: itemsPerPage,
          array_element_position: index,
          ...attributeOverrides
        }
      );
      const mapperConfig = {
        parent_element: carouselType
      };
      const products = additionalItems ? additionalItems.map(
        (item2, index2) => mapProductWithMappers(
          index2,
          item2,
          productMappers,
          mapperConfig,
          currentPage
        )
      ) : [
        mapProductWithMappers(
          index,
          item,
          productMappers,
          mapperConfig,
          currentPage
        )
      ];
      trackProductActionEvent(
        D.Click,
        customAttributes,
        products
      );
      if ((_a = products[0].custom_attributes) == null ? void 0 : _a.ad_id) {
        updateKonversion(
          (_c = (_b = products[0].custom_attributes) == null ? void 0 : _b.advertiser_name) == null ? void 0 : _c.toLowerCase(),
          konversionType.Click,
          ((_d = products[0].custom_attributes) == null ? void 0 : _d.ad_click_event_url) ?? ""
        );
      }
    },
    [
      carouselType,
      carouselTrackingConfig == null ? void 0 : carouselTrackingConfig.device,
      eventMappers,
      event,
      attributeOverrides,
      productMappers,
      trackProductActionEvent
    ]
  );
  return { logEvent };
}
const defaultKeyGenerator = (item) => item.id;
function useCallbackByParamTracking(key, callback, options) {
  const { keyGenerator = defaultKeyGenerator } = options ?? {};
  const tracked = useRef({});
  const setTracked = useCallback(
    (untrackedItems) => {
      untrackedItems.forEach((item) => {
        const id = keyGenerator(item);
        tracked.current[id][key] = true;
      });
    },
    [key, keyGenerator]
  );
  const trackedCallback = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function callbackFn(items, ...args) {
      const untrackedItems = items.filter((item) => {
        const id = keyGenerator ? keyGenerator(item) : item;
        if (!tracked.current[id]) {
          tracked.current[id] = {};
          return true;
        }
        if (!tracked.current[id][key]) {
          return true;
        }
        return false;
      });
      const returnValue = callback(untrackedItems, ...args);
      if (returnValue instanceof Promise) {
        returnValue.then(() => {
          setTracked(untrackedItems);
        });
      } else {
        setTracked(untrackedItems);
      }
      return returnValue;
    },
    [callback, key, keyGenerator, setTracked]
  );
  return trackedCallback;
}
const useCarouselImpressionTracking = (carouselType, items, productMappers, attributeOverrides, event = r.impression_shophome_carousel, carouselTrackingConfig) => {
  const { trackEvent } = useMparticle();
  const logEvent = useCallback(
    async (indices, eventAttributes = {}) => {
      const currentPage = Math.floor(indices[indices.length - 1] / indices.length) + 1;
      const visibleItemsAndIdx = indices.reduce(
        (acc, itemIndex) => ({
          ...acc,
          [itemIndex]: items[itemIndex]
        }),
        {}
      );
      const mapperConfig = {
        parent_element: carouselType,
        device: carouselTrackingConfig == null ? void 0 : carouselTrackingConfig.device
      };
      const products = Object.keys(visibleItemsAndIdx).reduce(
        (arrAcc, idx) => {
          const productInfo = (productMappers || []).reduce(
            (acc, productMapper) => {
              const newProduct = productMapper(
                Number(idx),
                visibleItemsAndIdx[Number(idx)],
                mapperConfig
              );
              return {
                ...acc,
                ...newProduct,
                custom_attributes: {
                  array_element_pagination: currentPage,
                  array_element_position: Number(idx),
                  ...acc.custom_attributes,
                  ...newProduct.custom_attributes
                }
              };
            },
            {}
          );
          return [...arrAcc, productInfo];
        },
        []
      );
      const token = await getAuthToken();
      const isSignedIn = !!(token && !isAuthTokenExpired());
      const customAttributes = {
        cashrewards_event_name: event,
        signed_in: isSignedIn,
        array_element_id: carouselType,
        array_element_type: W.carousel,
        array_element_pagination: currentPage,
        array_element_page_count: indices.length,
        ...attributeOverrides,
        ...eventAttributes
      };
      trackEvent(event, u.Other, customAttributes, products);
      const ads = products.filter((p) => {
        var _a;
        return (_a = p.custom_attributes) == null ? void 0 : _a.ad_id;
      });
      ads.forEach(
        (a) => {
          var _a, _b, _c;
          return updateKonversion(
            (_b = (_a = a.custom_attributes) == null ? void 0 : _a.advertiser_name) == null ? void 0 : _b.toLowerCase(),
            konversionType.View,
            ((_c = a.custom_attributes) == null ? void 0 : _c.ad_view_event_url) ?? ""
          );
        }
      );
    },
    [
      attributeOverrides,
      carouselType,
      carouselTrackingConfig == null ? void 0 : carouselTrackingConfig.device,
      event,
      items,
      productMappers,
      trackEvent
    ]
  );
  const _onRendered = useCallback(
    (renderedItems, eventAttributes) => {
      const indices = renderedItems.map((item) => items.indexOf(item));
      logEvent(indices, eventAttributes);
    },
    [items, logEvent]
  );
  const onMounted = useCallback(
    async (indices, eventAttributes) => {
      await logEvent(indices, eventAttributes);
    },
    [logEvent]
  );
  const onRendered = useCallbackByParamTracking("1", _onRendered);
  const onVisibleItemsChanged = useCallback(
    async (indices, eventAttributes) => {
      await logEvent(indices, eventAttributes);
    },
    [logEvent]
  );
  return {
    onMounted,
    onVisibleItemsChanged,
    onRendered
  };
};
export {
  M as MparticleProvider,
  TrackAllActionItems,
  T as TrackElementImpression,
  m as TrackPageScroll,
  l as TrackPageView,
  articleClickEventMapper,
  articleProductMapper,
  bannerProductMapper,
  categoryBannerProductMapper,
  offerBannerClickEventMapper,
  offerBannerEventMapper,
  offerBannerProductMapper,
  offerClickEventMapper,
  offerProductMapper,
  runOfMarketClickEventMapper,
  runOfMarketProductMapper,
  secondaryBannerProductMapper,
  storeClickEventMapper,
  storeProductMapper,
  useCarouselClickTracking,
  useCarouselImpressionTracking,
  useMparticle
};
